module.exports = __webpack_public_path__ + "img/tuihuo-h.737bc26a.svg";